import React, { useEffect, useState } from 'react'
import styles from './timeSheetList.module.css'

import { useLocation, useNavigate } from "react-router-dom";
import cleanerOne from "../../../assets/cleanerOne.png";
import cleanerTwo from "../../../assets/cleanerTwo.png";
import plusIcon from "../../../assets/plusIcon.png";
import { DatePicker, List } from "antd";
import { AntdDropdown, SearchInput } from '../../../components';
import { useTranslation } from 'react-i18next';
import './override.css'
import { FaCalendarAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import TimeSheetMiddleware from '../../../store/Middlewares/TimeSheetMiddleware';
import AlertAction from '../../../store/Actions/AlertActions';
import moment from 'moment';
import { MdSearch } from 'react-icons/md';


const TimeSheetList = () => {
    const navigate = useNavigate();

    useEffect(() => {
        getTimeSheetList();
        getLanguage();
    }, [])
    const { state } = useLocation();

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const data = state
    const [SelectedLocation, setSelectedLocation] = useState('')
    const [dateFrom, setdateFrom] = useState('')
    const [dateFromModal, setdateFromModal] = useState(false)
    const [dateTo, setdateTo] = useState('')
    const [dateToModal, setdateToModal] = useState(false)
    const [date, setDate] = useState(new Date())
    const TimeSheetList = useSelector(state => state.TimeSheetReducer.TimeSheetList)
    const TimeSheetListPagination = useSelector(state => state.TimeSheetReducer.TimeSheetListPagination)


    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language)
        } catch (e) {
            console.log(e)
        }
    };

    const getTimeSheetList = () => {
        let userData = {
            cleaner_id: data?.id,
            location_id: SelectedLocation,
            date_from: dateFrom,
            date_to: dateTo,
            next_page_url: undefined
        }
        dispatch(TimeSheetMiddleware.getTimeSheetList(userData))
    }

    const onSearchTimeSheetList = () => {
        if ((!dateFrom && !dateTo) || (dateFrom && dateTo)) {
            let userData = {
                cleaner_id: data?.id,
                location_id: SelectedLocation,
                date_from: dateFrom,
                date_to: dateTo,
                next_page_url: undefined
            }
            dispatch(TimeSheetMiddleware.getTimeSheetList(userData))
        }
        else if ((dateFrom && !dateTo) || (dateTo && !dateFrom)) {
            dispatch(AlertAction.ShowAlert({ type: "error", message: 'Please select date from and date to!' }))
            // Alert.alert('Note', 'Please select date from and date to!')
        }
    }

    const onPressLoadMore = () => {
        let userData = {
            cleaner_id: data?.id,
            location_id: SelectedLocation,
            date_from: dateFrom,
            date_to: dateTo,
            next_page_url: TimeSheetListPagination?.links?.next,
        }
        dispatch(TimeSheetMiddleware.getTimeSheetList(userData))
    };

    const loadMore =
        TimeSheetListPagination?.links?.next ? (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                    display: 'flex', justifyContent: 'center'
                }}
            >
                <button onClick={onPressLoadMore} className={styles.loadMore_button}>
                    Load More
                </button>
            </div>
        ) : null;

    const dummyChecklist = [
        {
            id: 1,
            date: "06-29-2023",
            customerName: "Mr. James",
            cleanerName: "Jason Smith",
            category: 'Custodial Engineer',
            TimeIn: "10:00 AM",
            TimeOut: "5:00 PM",
            Hours: "5 Hr 30 Min",
            Location: '8675, New York City',
            BHours: '1 Hour'
        },
        {
            id: 2,
            date: "06-29-2023",
            customerName: "Mr. James",
            cleanerName: "Jason Smith",
            category: 'Custodial Engineer',
            TimeIn: "10:00 AM",
            TimeOut: "5:00 PM",
            Hours: "5 Hr 30 Min",
            Location: '8675, New York City',
            BHours: '1 Hour'
        }
    ];
    const handleChange = value => {
        // console.log(value);
    };
    return (
        <div className={styles.home_mainContainer}>
            <h1 className={styles.heading}>{t("Time Sheet List")}</h1>
            <div className={styles.createChecklist_mainContainer}>
                <div className={styles.filterCont}>

                    <div className={styles.filterItem}>
                        <DatePicker
                            className={'datePicker'}
                            placeholder={"Date From"}
                            suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
                            onChange={(data, dateString) => setdateFrom(moment(dateString).format('YYYY-MM-DD'))}
                        />
                    </div>
                    <div className={styles.filterItem}>
                        <DatePicker
                            className={'datePicker'}
                            placeholder={"Date To"}
                            suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
                            onChange={(data, dateString) => setdateTo(moment(dateString).format('YYYY-MM-DD'))}
                        />
                    </div>
                    <div className={styles.filterItem}>
                        <AntdDropdown
                            // name={'Status'}
                            // label={'Role'}
                            placeholder={'Select Location'}
                            className={'yellow_border_class'}
                            onChange={(val) => setSelectedLocation(val)}
                            options={
                                data?.address?.map((item) => { return ({ value: item?.id, option: item?.address }) })
                            }
                            // options={[{ value: 'Calendar_Schedule', option: 'Calendar Schedule' },
                            // { value: 'Time_Sheet', option: 'Time Sheet' }]}
                            style={{ width: '100%', height: '20px', borderColor: 'red' }}
                        />
                    </div>
                    <div className={styles.filterItem}>
                        <button onClick={() => onSearchTimeSheetList()} className={styles.Search_button}>
                            <MdSearch
                                style={{ width: 20, height: 20 }}
                                color={"#ffff"}
                            />
                            Search
                        </button>
                        {/* <SearchInput placeholder={"Search"} style={{ width: '100%', marginTop: '2px', height: '45px', color: 'var(--secondary-color)' }} /> */}
                    </div>
                </div>
                <List
                    grid={{
                        gutter: 16,
                        //   xs: 2,
                        sm: 1,
                        md: 1,
                        lg: 1,
                        xl: 2,
                        xxl: 2,
                    }}
                    // className={styles.createChecklist_list}
                    dataSource={TimeSheetList}
                    footer={loadMore}
                    style={{ width: '100%' }}
                    renderItem={(item) => (
                        <div key={item?.id} className={styles.createChecklist_listItem}>
                            <div className={styles.createChecklist_context}>
                                <div className={styles.createChecklist_heading}>
                                    <p>{item?.location?.address}</p>
                                </div>
                                <div className={styles.createChecklist_heading}>
                                    <h3>{data?.name}</h3>
                                </div>
                                <div className={styles.createChecklist_heading}>
                                    <p>{moment(item?.date).format('MM-DD-YYYY')}</p>
                                </div>
                                <div className={styles.dataCont}>
                                    <div style={{ width: '100%' }}>
                                        <p className={styles.schedule_heading}>{t('Customer Name')}</p>
                                        <p className={styles.createChecklist_para}>{item?.customer_name}</p>
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <p className={styles.schedule_heading}>{t('Cleaner Name')}</p>
                                        <p className={styles.createChecklist_para}>{item?.cleaner_name}</p>
                                    </div>
                                </div>
                                <div className={styles.dataCont}>
                                    <div style={{ width: '100%' }}>
                                        <p className={styles.schedule_heading}>{t('Time In')}</p>
                                        <p className={styles.createChecklist_para}>{moment(item?.time_in).format('LT')}</p>
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <p className={styles.schedule_heading}>{t('Time Out')}</p>
                                        <p className={styles.createChecklist_para}>{moment(item?.time_out).format('LT')}</p>
                                    </div>
                                </div>
                                <div className={styles.dataCont}>
                                    <div style={{ width: '100%' }}>
                                        <p className={styles.schedule_heading}>{t('Break Hours')}</p>
                                        <p className={styles.createChecklist_para}>{item?.break_time ? item?.break_time : 'N/A'}</p>
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <p className={styles.schedule_heading}>{t('Total Hours')}</p>
                                        <p className={styles.createChecklist_para}>{item?.job_time}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default TimeSheetList